<template>
  <div>
    <div class="row">
      <div class="col-lg-12">
        <!-- ONT发现PON配置列表 -->
        <block-cntr :btitle="'ONT Find Config'" style="height: 410px">
          <div class="form-inline">
            <span style="float: left">
              <div class="btn-group open">
                <div
                  @click="clkEdit()"
                  class="btn"
                  :class="{ disabled: false }"
                  style="padding: 0px"
                >
                  <i class="fa fa-edit page-tableaction"></i>
                </div>
              </div>
            </span>
          </div>
          <!--发现配置列表-->
          <table class="table table-hover table-noneborder-top">
            <thead>
              <tr>
                <th width="40px">
                  <input
                    type="checkbox"
                    v-model="isSelectAll"
                    @change="changeSelectAll()"
                    id="idSelectAllPort"
                  />
                  <label for="idSelectAllPort"></label>
                </th>
                <th
                  v-for="(value, key) in ontFindConfigTable.title"
                  :key="key"
                  :title="value"
                >
                  {{ value }}
                </th>
              </tr>
            </thead>
            <tbody style="height: 350px">
              <tr
                v-for="(row, index) in ontFindConfigTable.data"
                :key="row.port"
                :class="{ 'true:': true }"
              >
                <td width="40px">
                  <div v-if="!row.isNew">
                    <input
                      type="checkbox"
                      v-model="row.selected"
                      :id="'idRowSelectAlarm' + index"
                    />
                    <label :for="'idRowSelectAlarm' + index"></label>
                  </div>
                </td>
                <td>
                  <div>{{ row.port }}</div>
                </td>
                <td>
                  <div>{{ row.find }}</div>
                </td>
                <td>
                  <div>{{ row.interval }}</div>
                </td>
                <td>
                  <div>{{ row.age }}</div>
                </td>
                <td>
                  <div>{{ row.ageTime }}</div>
                </td>
                <td>
                  <div>{{ row.distanceMin }}</div>
                </td>
                <td>
                  <div>{{ row.distanceMax }}</div>
                </td>
              </tr>
            </tbody>
          </table>

          <!--配置-->
          <div v-if="isShowConfigTable">
            <dialog-box
              :btitle="'ONT Find Config Edit'"
              @close="isShowConfigTable = false"
              style="min-height: 410px"
            >
              <form class="form-horizontal" role="form">
                <div class="form-group">
                  <label class="col-sm-3 control-label" for="findAdmin"
                    >Find Admin</label
                  >
                  <div class="col-sm-5">
                    <select
                      type="text"
                      class="form-control"
                      id="findAdmin"
                      @change="changeFindAdmin()"
                      v-model="findConfigForm.find"
                    >
                      <option label="enable" value="1"></option>
                      <option label="disable" value="0"></option>
                    </select>
                  </div>
                </div>

                <div class="form-group">
                  <label class="col-sm-3 control-label" for="interval"
                    >Interval</label
                  >
                  <div
                    class="col-sm-5"
                    :class="{
                      'has-error': checkParameters(
                        'interval',
                        findConfigForm.interval
                      ),
                    }"
                  >
                    <input
                      type="text"
                      class="form-control"
                      id="interval"
                      v-model="findConfigForm.interval"
                      placeholder="INTEGER<20-30>(s)"
                      :disabled="findConfigForm.find == '0'"
                      autocomplete="off"
                    />
                    <small
                      class="help-block"
                      :style="{
                        display: checkParameters(
                          'interval',
                          findConfigForm.interval
                        )
                          ? 'block'
                          : 'none',
                      }"
                      >{{
                        checkParameters("interval", findConfigForm.interval)
                      }}
                    </small>
                  </div>
                </div>

                <div class="form-group">
                  <label class="col-sm-3 control-label" for="ageAdmin"
                    >Age</label
                  >
                  <div class="col-sm-5">
                    <select
                      type="text"
                      class="form-control"
                      id="ageAdmin"
                      @change="changeAgeAdmin()"
                      v-model="findConfigForm.age"
                    >
                      <option label="enable" value="1"></option>
                      <option label="disable" value="0"></option>
                    </select>
                  </div>
                </div>

                <div class="form-group">
                  <label class="col-sm-3 control-label" for="ageTime"
                    >Age Time</label
                  >
                  <div
                    class="col-sm-5"
                    :class="{
                      'has-error': checkParameters(
                        'ageTime',
                        findConfigForm.ageTime
                      ),
                    }"
                  >
                    <input
                      type="text"
                      class="form-control"
                      id="ageTime"
                      v-model="findConfigForm.ageTime"
                      placeholder="INTEGER<1-86400>(s)"
                      :disabled="findConfigForm.age == '0'"
                      autocomplete="off"
                    />
                    <small
                      class="help-block"
                      :style="{
                        display: checkParameters(
                          'ageTime',
                          findConfigForm.ageTime
                        )
                          ? 'block'
                          : 'none',
                      }"
                      >{{ checkParameters("ageTime", findConfigForm.ageTime) }}
                    </small>
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-sm-3 control-label" for="distanceMin"
                    >Distance Min</label
                  >
                  <div
                    class="col-sm-5"
                    :class="{
                      'has-error': checkParameters(
                        'distanceMin',
                        findConfigForm.distanceMin
                      ),
                    }"
                  >
                    <input
                      type="text"
                      class="form-control"
                      id="distanceMin"
                      v-model="findConfigForm.distanceMin"
                      placeholder="INTEGER<0-40>(km)"
                      autocomplete="off"
                    />
                    <small
                      class="help-block"
                      :style="{
                        display: checkParameters(
                          'distanceMin',
                          findConfigForm.distanceMin
                        )
                          ? 'block'
                          : 'none',
                      }"
                      >{{
                        checkParameters(
                          "distanceMin",
                          findConfigForm.distanceMin
                        )
                      }}
                    </small>
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-sm-3 control-label" for="distanceMax"
                    >Distance Max</label
                  >
                  <div
                    class="col-sm-5"
                    :class="{
                      'has-error': checkParameters(
                        'distanceMax',
                        findConfigForm.distanceMax
                      ),
                    }"
                  >
                    <input
                      type="text"
                      class="form-control"
                      id="distanceMax"
                      v-model="findConfigForm.distanceMax"
                      placeholder="INTEGER<0-60>(km)"
                      auto
                      complete="off"
                    />
                    <small
                      class="help-block"
                      :style="{
                        display: checkParameters(
                          'distanceMax',
                          findConfigForm.distanceMax
                        )
                          ? 'block'
                          : 'none',
                      }"
                      >{{
                        checkParameters(
                          "distanceMax",
                          findConfigForm.distanceMax
                        )
                      }}
                    </small>
                  </div>
                </div>

                <button
                  type="button"
                  class="btn btn-primary"
                  style="
                    margin-left: 20%;
                    min-width: 77px;
                    color: #fff;
                    background-color: #008b8b;
                    border-color: #008080;
                  "
                  @click="clkApply()"
                >
                  {{ "Apply" }}
                </button>
                <span style="margin-left: 10px">
                  <button
                    type="button"
                    class="btn btn-default"
                    style="min-width: 77px"
                    @click="clkCancel()"
                  >
                    {{ "Cancel" }}
                  </button>
                </span>
              </form>
            </dialog-box>
          </div>
        </block-cntr>
      </div>
    </div>

    <info-box :ibox="iBox"></info-box>
  </div>
</template>

<script>
import en from "./../lang/en-US.js"
import BlockCntr from "./../components/BlockCntr.vue"
import InfoBox from "@/components/InfoBox.vue"
import DialogBox from "@/components/DialogBox"
import { get, post } from "@/utils/http.js"

export default {
  components: {
    BlockCntr,
    InfoBox,
    DialogBox,
  },
  data() {
    return {
      isShowConfigTable: false,
      isEditClik: false,
      isSelectAll: false,
      iBox: {},
      ontFindConfigTable: "",
      findConfigForm: {
        port: "",
        find: "",
        interval: "",
        age: "",
        ageTime: "",
        distanceMin: "",
        distanceMax: "",
      },
    }
  },
  created() {
    this.loadOntFindConfigTable()
  },
  methods: {
    loadOntFindConfigTable() {
      get("ontFindConfig")
        .then((res) => (this.ontFindConfigTable = res.data))
        .catch((err) => {
          this.ontFindConfigTable = en.findConfig
        })
    },
    clkEdit() {
      for (let i = 0; i < this.ontFindConfigTable.data.length; i++) {
        if (this.ontFindConfigTable.data[i].selected) {
          if (this.ontFindConfigTable.data[i].find == "enable") {
            this.findConfigForm.find = "1"
          } else {
            this.findConfigForm.find = "0"
          }
          this.findConfigForm.interval =
            this.ontFindConfigTable.data[i].interval
          if (this.ontFindConfigTable.data[i].age == "enable") {
            this.findConfigForm.age = "1"
          } else {
            this.findConfigForm.age = "0"
          }
          this.findConfigForm.ageTime = this.ontFindConfigTable.data[i].ageTime
          this.findConfigForm.distanceMin =
            this.ontFindConfigTable.data[i].distanceMin
          this.findConfigForm.distanceMax =
            this.ontFindConfigTable.data[i].distanceMax
          this.isShowConfigTable = true
          this.isEditClik = true
          return
        }
      }
    },
    clkCancel() {
      this.isShowConfigTable = false
      console.log(this.isShowConfigTable)
    },
    changeSelectAll() {
      for (let i = 0; i < this.ontFindConfigTable.data.length; i++) {
        if (this.isSelectAll) {
          this.ontFindConfigTable.data[i].selected = true
        } else {
          this.ontFindConfigTable.data[i].selected = false
        }
      }
    },
    selectNull() {
      for (let i = 0; i < this.ontFindConfigTable.data.length; i++) {
        this.ontFindConfigTable.data[i].selected = false
      }
      this.isSelectAll = false
    },

    clkApply() {
      var list = []
      var findConfig = {
        find: Number(this.findConfigForm.find),
        interval: Number(this.findConfigForm.interval),
        age: Number(this.findConfigForm.age),
        ageTime: Number(this.findConfigForm.ageTime),
        distanceMin: Number(this.findConfigForm.distanceMin),
        distanceMax: Number(this.findConfigForm.distanceMax),
        portList: [],
      }

      if (this.findConfigForm.interval == "") {
        findConfig.interval = -1
      } else {
        if (this.checkParameters("interval", this.findConfigForm.interval)) {
          this.showAlertBox("warn", "Message", "Invalid interval")
          return
        }
      }
      if (this.findConfigForm.ageTime == "") {
        findConfig.ageTime = -1
      } else {
        if (this.checkParameters("ageTime", this.findConfigForm.ageTime)) {
          this.showAlertBox("warn", "Message", "Invalid ageTime")
          return
        }
      }
      if (this.findConfigForm.distanceMin == "") {
        findConfig.distanceMin = -1
      } else {
        if (
          this.checkParameters("distanceMin", this.findConfigForm.distanceMin)
        ) {
          this.showAlertBox("warn", "Message", "Invalid distanceMin")
          return
        }
      }
      if (this.findConfigForm.distanceMax == "") {
        findConfig.distanceMax = -1
      } else {
        if (
          this.checkParameters("distanceMax", this.findConfigForm.distanceMax)
        ) {
          this.showAlertBox("warn", "Message", "Invalid distanceMax")
          return
        }
      }

      for (let i = 0; i < this.ontFindConfigTable.data.length; i++) {
        if (this.ontFindConfigTable.data[i].selected) {
          list.push({ gponPort: this.ontFindConfigTable.data[i].port })
        }
      }
      findConfig["portList"] = list
      post("ontFindConfig", findConfig)
        .then((res) => {
          console.log(res)
          if (
            res.data == undefined ||
            res.data.code === undefined ||
            res.data.code === 0
          ) {
            this.loadOntFindConfigTable()
            this.showAlertBox("info", "Info", "Config Successful!")
          } else {
            this.showAlertBox("warn", "Message", res.data.msg)
          }
        })
        .catch((err) => {
          this.showAlertBox("critical", "error", err)
        })
      this.isShowConfigTable = false
      this.selectNull()
    },

    changeFindAdmin() {
      if (this.findConfigForm.find == "0") {
        this.findConfigForm.interval = ""
      }
    },

    changeAgeAdmin() {
      if (this.findConfigForm.age == "0") {
        this.findConfigForm.ageTime = ""
      }
    },
    checkParameters(type, value) {
      if (value === "") {
        return null
      }
      if (type == "interval") {
        if (isNaN(Number(value)) || Number(value) < 20 || Number(value) > 30) {
          return "interval must be in range 20-30"
        }
      } else if (type == "ageTime") {
        if (
          isNaN(Number(value)) ||
          Number(value) < 1 ||
          Number(value) > 86400
        ) {
          return "ageTime must be in range 1-86400"
        }
      } else if (type == "distanceMin") {
        if (isNaN(Number(value)) || Number(value) < 0 || Number(value) > 40) {
          return "distanceMin must be in range 0-40"
        }
      } else if (type == "distanceMax") {
        if (isNaN(Number(value)) || Number(value) < 0 || Number(value) > 60) {
          return "distanceMax must be in range 0-60"
        }
      }
      return null
    },

    /* 告警弹框 */
    showAlertBox(type, title, txt) {
      this.iBox = {
        visible: true,
        type: type, // info warn critical
        title: title,
        txt: txt,
        btxt: "Close",
      }
    },
  },
}
</script>